import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=64284988&scoped=true"
import script from "./AppBar.vue?vue&type=script&lang=ts"
export * from "./AppBar.vue?vue&type=script&lang=ts"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=64284988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64284988",
  null
  
)

export default component.exports